import { SigInScreen } from "./auth/SignInScreen";
import { SignUpScreen } from "./auth/SignUpScreen";
import { UpdateAccountScreen } from "./UpdateAcccountScreen";
import { NewPassword } from "./NewPassword";
import { ProfileEdit } from "./ProfileEdit";
import { LanguageScreen } from "./LanguageScreen";
import { CategoryGrid } from "./CategoryGrid";
import { ForgotPassword } from "./ForgotPassword";
import { VerificationScreen } from "./VerificationScreen";
import { WithdrawScreen } from "./WithdrawScreen";
import { WithdrawPasswordScreen } from "./WithdrawPasswordScreen";

// Tabs
import { Home } from "./tabs/Home";
import { ProfileScreen } from "./tabs/Profile";
import { MyTrades } from "./tabs/myTrades/MyTrades";
import { TabNavigator } from "../navigation/TabNavigator";
import { SettingsScreen } from "./SettingsScreen";
import { AuthScreen } from "./auth/AuthScreen";
import { UpdatePasswordScreen } from "./UpdatePasswordScreen";
import { PersonalScreen } from "./profile/PersonalScreen";
import { ChatScreen } from "./chat/ChatScreen";
import { TransactionsScreen } from "./profile/TransactionsScreen";

export const screens = {
  Home,
  SigInScreen,
  AuthScreen,
  SignUpScreen,
  LanguageScreen,
  ProfileScreen,
  SettingsScreen,
  UpdateAccountScreen,
  MyTrades,
  ProfileEdit,
  NewPassword,
  CategoryGrid,
  ForgotPassword,
  VerificationScreen,
  WithdrawScreen,
  WithdrawPasswordScreen,
  TabNavigator,
  UpdatePasswordScreen,
  PersonalScreen,
  ChatScreen,
  TransactionsScreen,
};
